import React from 'react';

export default function TitleLooklikeButton({ title }) {
  return (
    <span className="header_button_with_shadow shadow-md border border-[#e2e2e2] rounded-full px-6 py-3 flex  justify-center align-center w-fit text-xl">
      {title}
    </span>
  );
}
